import { defineStore } from "pinia";

import { TCurrentUser } from "@/data/api/kili/current-user/current-user.type";

interface IState {
  currentUser: TCurrentUser | undefined;
}

export const useCurrentUserStore = defineStore("current-user", {
  state: (): IState => {
    return {
      currentUser: undefined,
    };
  },
  actions: {
    async login(user: TCurrentUser) {
      this.currentUser = user;
    },
    logout() {
      this.currentUser = undefined;
    },
  },
});
